(() => {
  'use strict';
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.g-mobile-menu[open]').forEach((menu) => {menu.open = false;menu.querySelector('summary')?.focus();});
  });
  document.addEventListener('click', (event) => {
    const target = event.target.closest('.g-mobile-menu nav a');
    if (target) target.closest('details').open = false;
  });
  function initializeProducts(root = document) {
    root.querySelectorAll('[data-product-section]').forEach((section) => {
      const select = section.querySelector('[data-variant-select]');
      if (!select || select.dataset.initialized) return;
      select.dataset.initialized = 'true';

      const colorSwatches = Array.from(section.querySelectorAll('[data-color-swatch]'));
      const sizePills = Array.from(section.querySelectorAll('[data-size-pill]'));
      const colorLabel = section.querySelector('[data-selected-color-label]');
      const options = Array.from(select.options);

      function getSelectedColor() {
        const active = colorSwatches.find((btn) => btn.classList.contains('is-active'));
        if (active) return active.dataset.colorSwatch;
        return select.selectedOptions[0]?.dataset.color || '';
      }

      function getSelectedSize() {
        const active = sizePills.find((btn) => btn.classList.contains('is-active'));
        if (active) return active.dataset.sizePill;
        return select.selectedOptions[0]?.dataset.size || '';
      }

      function findMatchingOption(color, size) {
        return (
          options.find((opt) => opt.dataset.color === color && opt.dataset.size === size) ||
          options.find((opt) => opt.dataset.color === color && opt.dataset.available === 'true') ||
          options.find((opt) => opt.dataset.color === color) ||
          options.find((opt) => opt.dataset.size === size) ||
          select.selectedOptions[0]
        );
      }

      function syncSwatchesAndPills(option) {
        if (!option) return;
        const activeColor = option.dataset.color || '';
        const activeSize = option.dataset.size || '';
        if (colorLabel && activeColor) colorLabel.textContent = activeColor;
        colorSwatches.forEach((btn) => {
          const isMatch = btn.dataset.colorSwatch === activeColor;
          btn.classList.toggle('is-active', isMatch);
          btn.setAttribute('aria-pressed', isMatch ? 'true' : 'false');
        });
        sizePills.forEach((btn) => {
          const sz = btn.dataset.sizePill;
          const isMatch = sz === activeSize;
          btn.classList.toggle('is-active', isMatch);
          btn.setAttribute('aria-pressed', isMatch ? 'true' : 'false');
          const pairOpt = options.find((opt) => opt.dataset.color === activeColor && opt.dataset.size === sz);
          const isAvail = pairOpt ? pairOpt.dataset.available === 'true' : true;
          btn.classList.toggle('is-unavailable', !isAvail);
        });
      }

      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        if (!option) return;
        syncSwatchesAndPills(option);
        const price = section.querySelector('[data-product-price]');
        const compare = section.querySelector('[data-product-compare-price]');
        const submit = section.querySelector('[data-product-submit]');
        const status = section.querySelector('[data-product-status]');
        const available = option.dataset.available === 'true';
        if (price) price.textContent = option.dataset.price || '';
        if (compare) {compare.textContent = option.dataset.comparePrice || '';compare.hidden = !option.dataset.comparePrice;}
        if (submit) {submit.disabled = !available;submit.textContent = available ? 'Add to bag' : 'Sold out';}
        if (status) status.textContent = available ? '' : 'This option is sold out.';
        const image = section.querySelector('[data-product-image]');
        if (image && option.dataset.image) {
          image.removeAttribute('srcset');
          image.src = option.dataset.image;
          image.alt = option.dataset.imageAlt || image.alt;
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url);
      });

      colorSwatches.forEach((btn) => {
        btn.addEventListener('click', () => {
          const targetColor = btn.dataset.colorSwatch;
          const currentSize = getSelectedSize();
          const match = findMatchingOption(targetColor, currentSize);
          if (match) {
            select.value = match.value;
            select.dispatchEvent(new Event('change'));
          }
        });
      });

      sizePills.forEach((btn) => {
        btn.addEventListener('click', () => {
          const targetSize = btn.dataset.sizePill;
          const currentColor = getSelectedColor();
          const match = findMatchingOption(currentColor, targetSize);
          if (match) {
            select.value = match.value;
            select.dispatchEvent(new Event('change'));
          }
        });
      });

      const initialOption = select.selectedOptions[0];
      syncSwatchesAndPills(initialOption);
      if (initialOption && initialOption.value) {
        const initUrl = new URL(window.location.href);
        if (initUrl.searchParams.get('variant') !== initialOption.value) {
          initUrl.searchParams.set('variant', initialOption.value);
          window.history.replaceState({}, '', initUrl);
        }
      }

      section.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
        thumb.addEventListener('click', (event) => {
          event.preventDefault();
          const image = section.querySelector('[data-product-image]');
          if (image && thumb.dataset.galleryThumb) {
            image.removeAttribute('srcset');
            image.src = thumb.dataset.galleryThumb;
            image.alt = thumb.dataset.galleryAlt || image.alt;
          }
          if (thumb.dataset.galleryColor) {
            const match = findMatchingOption(thumb.dataset.galleryColor, getSelectedSize());
            if (match) {
              select.value = match.value;
              select.dispatchEvent(new Event('change'));
              return;
            }
          }
          if (thumb.dataset.variantId && select) {
            const matchingOption = select.querySelector(`option[value="${thumb.dataset.variantId}"]`);
            if (matchingOption) {
              select.value = thumb.dataset.variantId;
              select.dispatchEvent(new Event('change'));
            }
          }
        });
      });
      const shareBtn = section.querySelector('[data-product-share]');
      if (shareBtn && !shareBtn.dataset.initialized) {
        shareBtn.dataset.initialized = 'true';
        const defaultLabel = shareBtn.textContent;
        shareBtn.addEventListener('click', async () => {
          const shareUrlObj = new URL(window.location.href);
          if (select && select.value) {
            shareUrlObj.searchParams.set('variant', select.value);
          }
          const shareUrl = shareUrlObj.toString();
          const shareTitle = shareBtn.dataset.shareTitle || document.title;
          if (navigator.share) {
            try {
              await navigator.share({ title: shareTitle, url: shareUrl });
              return;
            } catch (err) {
              if (err && err.name === 'AbortError') return;
            }
          }
          try {
            await navigator.clipboard.writeText(shareUrl);
          } catch (_) {
            const input = document.createElement('input');
            input.value = shareUrl;
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
          }
          shareBtn.textContent = 'Link copied! ( • _ • )';
          setTimeout(() => { shareBtn.textContent = defaultLabel; }, 2200);
        });
      }
    });
  }

  function initializeStorefrontSearch(root = document) {
    (root || document).querySelectorAll('[data-storefront-search]').forEach((input) => {
      if (input.dataset.searchTrackingBound === 'true') return;
      input.dataset.searchTrackingBound = 'true';

      let debounceTimer = null;
      let lastTrackedQuery = '';

      input.addEventListener('input', () => {
        const rawQuery = input.value || '';
        const query = rawQuery.trim();
        const normalized = query.toLowerCase();

        const container = input.closest('.g-collection-section, .g-collection, .g-search') || document;
        const cards = Array.from(container.querySelectorAll('.g-product-card'));
        const emptyState = container.querySelector('[data-search-empty]');
        const emptyQuerySpan = container.querySelector('[data-search-query]');
        const shopAllFooter = container.querySelector('[data-shop-all-footer]');
        let visibleCount = 0;

        if (cards.length > 0 && !container.classList.contains('g-search')) {
          cards.forEach((card) => {
            const isBeyondLimit = card.hasAttribute('data-beyond-limit');
            if (!normalized) {
              card.hidden = isBeyondLimit;
              if (!isBeyondLimit) visibleCount += 1;
              return;
            }
            const haystack = (card.getAttribute('data-search-text') || card.textContent || '').toLowerCase();
            const matches = haystack.includes(normalized);
            card.hidden = !matches;
            if (matches) visibleCount += 1;
          });

          if (emptyState) {
            if (emptyQuerySpan) emptyQuerySpan.textContent = query;
            emptyState.hidden = !(normalized.length > 0 && visibleCount === 0);
          }
          if (shopAllFooter) {
            shopAllFooter.hidden = normalized.length > 0;
          }
        } else {
          visibleCount = cards.filter((c) => !c.hidden).length;
        }

        if (debounceTimer) clearTimeout(debounceTimer);
        if (query.length < 3 || query === lastTrackedQuery) return;

        debounceTimer = setTimeout(() => {
          lastTrackedQuery = query;
          fetch('/search?q=' + encodeURIComponent(query), {
            method: 'HEAD',
            credentials: 'same-origin'
          }).catch(() => {});
          fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product', {
            method: 'GET',
            credentials: 'same-origin'
          }).catch(() => {});
          if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
            try {
              window.Shopify.analytics.publish('search_submitted', { searchResult: { query } });
            } catch (_) {}
          }
          if (window.gtag) {
            window.gtag('event', 'view_search_results', {
              search_term: query,
              results_count: visibleCount
            });
            if (visibleCount === 0) {
              window.gtag('event', 'zero_result_search', {
                search_term: query
              });
            }
          }
        }, 1000);
      });
    });
  }

  initializeProducts();
  initializeStorefrontSearch();
  document.addEventListener('shopify:section:load', (event) => {
    initializeProducts(event.target);
    initializeStorefrontSearch(event.target);
  });
})();
